import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-team-picture',
    templateUrl: './team-picture.component.html',
    styleUrls: ['./team-picture.component.scss'],
    standalone: false
})
export class TeamPictureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
